// extracted by mini-css-extract-plugin
module.exports = {"onboarding-next-button":"_3MFzE"};